module.exports = __webpack_public_path__ + "static/img/innoplastics.d8e0ee8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/innoplastics.png
// module id = 489
// module chunks = 1